import React, { useState, useEffect } from "react";
import "../App.css";

const images = [
  "/hero-bg.jpg",
  "/hero-bg2.jpg",
  "/hero-bg3.jpg",
  "/hero-bg4.jpg"
];

const BackgroundSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 6000); 
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="hero-slider">
        {images.map((img, index) => (
          <div 
            key={index}
            className={`hero-slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url('${img}')` }}
          />
        ))}
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-nav-container">
        {images.map((_, index) => (
          <div 
            key={index} 
            className={`hero-nav-box ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          >
             <span className="box-number">0{index + 1}</span>
             <div className="box-bar"></div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BackgroundSlider;
